import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { bibShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import Heading from 'app/components/shared/Heading';
import { fieldShape } from 'app/shapes/bibPage';
import CatalogContributors from './CatalogContributors';
import MovieContributors from './MovieContributors';

export default class Contributors extends React.PureComponent {
  renderContributors() {
    const { features } = this.context;
    const { bib, contributorNames, movie, trackFieldItemClick } = this.props;

    const superFormats = bib.getIn(['briefInfo', 'superFormats']);

    if (features.get(TOGGLZ_FEATURES.BIB_PAGE_MOVIE_TRAILERS) && superFormats.includes('MOVIES_TV_VIDEO')) {
      return movie && <MovieContributors cast={movie.getIn(['credits', 'cast'])} />;
    }

    return contributorNames?.size ? (
      <CatalogContributors contributorNames={contributorNames} trackFieldItemClick={trackFieldItemClick} />
    ) : null;
  }

  render() {
    const contributors = this.renderContributors();

    if (contributors) {
      return (
        <div className="cp-contributors">
          <Heading tagName="h3" size="medium" variant>
            <FormattedMessage id="bib_metadata_category_contributors" />
          </Heading>
          {contributors}
        </div>
      );
    }

    return null;
  }
}

Contributors.contextType = Context;

Contributors.propTypes = {
  bib: bibShape.isRequired,
  movie: ImmutablePropTypes.map,
  contributorNames: fieldShape,
  trackFieldItemClick: PropTypes.func.isRequired
};
